"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorridorsOfPower = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
class CorridorsOfPower extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.CORRIDORS_OF_POWER,
            tags: [Tags_1.Tags.EARTH],
            metadata: {
                cardNumber: 'P47',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.tr(1).megacredits(4);
                    b.preludeBox('effect', (ce) => {
                        ce.effect('Each time you become party leader, draw 1 card.', (eb) => {
                            eb.partyLeaders(1).startEffect.cards(1);
                        });
                    });
                }),
                description: 'Increase your terraform rating 1 step. Gain 4 M€.',
            },
        });
    }
    play(player) {
        player.increaseTerraformRatingSteps(1);
        player.addResource(Resources_1.Resources.MEGACREDITS, 4);
        return undefined;
    }
}
exports.CorridorsOfPower = CorridorsOfPower;
//# sourceMappingURL=CorridorsOfPower.js.map